import React from 'react';
import PropTypes from 'prop-types';

import OffRampDetails, { offRampDetailsProptypes } from '../OffRampDetails';

import styles from './index.module.css';

const OffRamp = ({
  offRamp: {
    createdAt,
    description,
    reference,
    status,
    totalAmount,
    tradedAmount,
    offRampUrl,
  },
}) => (
  <div className={styles.root}>
    <OffRampDetails
      createdAt={createdAt}
      description={description}
      reference={reference}
      status={status}
      totalAmount={totalAmount}
      tradedAmount={tradedAmount}
      offRampUrl={offRampUrl}
    />
  </div>
);

OffRamp.propTypes = {
  offRamp: PropTypes.shape(offRampDetailsProptypes).isRequired,
};

export default OffRamp;
